/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { campaignAnalysisStatusResponseSchema } from '../campaign-schema';

export const getCampaignAnalysisStatusPathSchema = z.object({
  campaignId: z.string(),
  runId: z.string(),
});

export const getCampaignAnalysisStatusOperationResponseSchema =
  campaignAnalysisStatusResponseSchema;

export type GetCampaignAnalysisStatusInput = {
  path: z.input<typeof getCampaignAnalysisStatusPathSchema>;
  signal?: AbortSignal;
};

export async function getCampaignAnalysisStatus({
  path,
  signal,
}: GetCampaignAnalysisStatusInput): Promise<
  z.infer<typeof getCampaignAnalysisStatusOperationResponseSchema>
> {
  const parsedPath = getCampaignAnalysisStatusPathSchema.parse(path);

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}/analyses/${parsedPath.runId}/status`,
    {
      signal,
    },
  );
  return getCampaignAnalysisStatusOperationResponseSchema.parse(
    await response.json(),
  );
}
